/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgVisualizeBloomBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.053 4.41812C11.7219 3.86063 12.7254 3.86063 13.3944 4.41812C14.2307 5.14286 14.6209 6.70383 13.5617 9.10105C13.1714 8.87805 12.6697 8.76655 12.2237 8.76655C11.7219 8.76655 11.2759 8.87805 10.8857 9.10105C9.77072 6.64808 10.2167 5.08711 11.053 4.41812ZM5.03204 9.21254C4.8648 8.32056 5.36654 7.48432 6.20278 7.14983C7.20626 6.75958 8.76724 7.20557 10.384 9.32404C9.60347 9.88153 9.10173 10.7178 9.04598 11.6655C6.42577 11.4425 5.25504 10.2718 5.03204 9.21254ZM6.25853 16.7944C5.42229 16.5157 4.92055 15.6237 5.08779 14.7317C5.25504 13.6725 6.42577 12.5017 9.04598 12.223C9.10173 13.2265 9.65922 14.0627 10.384 14.5645C8.82299 16.7387 7.26201 17.1847 6.25853 16.7944ZM13.3944 19.5819C12.7254 20.1394 11.7219 20.1394 11.053 19.5819C10.2167 18.8571 9.82647 17.2962 10.8857 14.899C11.2759 15.122 11.7777 15.2334 12.2237 15.2334C12.6697 15.2334 13.1714 15.122 13.5617 14.899C14.6209 17.2962 14.2307 18.8571 13.3944 19.5819ZM19.3596 14.7317C19.5268 15.6237 19.0251 16.4599 18.1888 16.7944C17.1854 17.1847 15.6244 16.7387 14.0077 14.6202C14.7881 14.0627 15.2899 13.2265 15.3456 12.2787C18.0216 12.5575 19.1923 13.6725 19.3596 14.7317ZM15.4014 11.7213C15.3456 10.7178 14.7881 9.88153 14.0634 9.37979C15.6244 7.26132 17.1854 6.81533 18.2446 7.20557C19.0808 7.48432 19.5826 8.37631 19.4153 9.26829C19.1923 10.2718 18.0216 11.4425 15.4014 11.7213Z"
      fill="currentColor"
    />
  </svg>
);
const SvgVisualizeBloom = wrapIcon(SvgVisualizeBloomBase);
export default SvgVisualizeBloom;
